import { Filter } from "./filter";
import { FilterGroup } from "./filterGroup";
export class Not extends FilterGroup {
  originalFilter?: Filter;
  constructor(override filters: Array<Filter>) {
    super("not", filters);
  }
}
